export enum TemplateType {
    TreatmentGiven = 1,
    HistoryNotes = 2,
    OperativeNote = 3,
    TreatmentAdvice = 4,
    Anesthesia = 5,
    DischargeCondition=6
}

export const TemplateTypeLabels: Record<TemplateType, string> = {
    [TemplateType.TreatmentGiven]: "Treatment Given",
    [TemplateType.HistoryNotes]: "History Notes",
    [TemplateType.OperativeNote]: "Operative Note",
    [TemplateType.TreatmentAdvice]: "Treatment Advice",
    [TemplateType.Anesthesia]: "Anesthesia",
    [TemplateType.DischargeCondition]: "Discharge Condition"
};
